import { render, staticRenderFns } from "./yiList.vue?vue&type=template&id=4091aa1d&scoped=true"
import script from "./yiList.vue?vue&type=script&lang=js"
export * from "./yiList.vue?vue&type=script&lang=js"
import style0 from "./yiList.vue?vue&type=style&index=0&id=4091aa1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4091aa1d",
  null
  
)

export default component.exports